import { Component } from "react";

class ServiceComponent extends Component 
{
    getServiceClasses (serviceSlug, extraClasses) 
    {
        var className = "";
        switch (serviceSlug) {
            case "paid-media":
                className = `${ extraClasses }-paid-media`;
                break;
            case "seo":
                className = `${ extraClasses }-seo`;
                break;
            case "development":
                className = `${ extraClasses }-development`;
                break;
            case "content-marketing":
                className = `${ extraClasses }-content-marketing`;
                break;
            case "pr":
                className = `${ extraClasses }-pr`;
                break;
            case "resting-pitch-face":
                className = `${ extraClasses }-resting-pitch-face`;
                break;
            case "company-updates":
                className = `${ extraClasses }-company-updates`;
                break;
            case "creative":
            case "creative-marketing":
                className = `${ extraClasses }-creative`;
                break;
            default:
                className = `${ extraClasses }-flaunt-digital`;
                break;
        }
        return className;
    }

    getService (services, serviceSlug, extraClass)
    {
        let serviceActual = null;
        if (services !== null) {
            services.forEach(service => {
                if (service.slug === serviceSlug)
                    serviceActual = {
                        "name": service.name, 
                        "slug": service.slug, 
                        "classes": this.getServiceClasses(service.slug, extraClass)
                    };
            });
        }
        return serviceActual;
    }
};
export default ServiceComponent;